<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务数据导出任务</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="任务类型"
                        prop="task_type">
            <el-select v-model="search.task_type"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option v-for="item in all_tasks"
                         :key="item.task_id"
                         :label="item.task_name"
                         :value="item.task_id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="80"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="task_type"
                         label="任务类型"
                         min-width="80">
          <template slot-scope="scope">
              <span v-for="item in all_tasks"
                    v-if="scope.row.task_type  + '' === item.task_id + ''">
                {{ item.task_name }}
              </span>
          </template>
        </el-table-column>

        <el-table-column prop="admin_name"
                         label="发起者"
                         width="80">
          <template slot-scope="scope">
            {{ scope.row.admin_name }} / {{ scope.row.admin_id }}
          </template>
        </el-table-column>
        <el-table-column label="任务进度"
                         min-width="100">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)">
            </sj-progress>
            成功:{{ scope.row.success_count }} 错误:{{ scope.row.error_count }}
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="150">
          <template slot-scope="scope">
            <span v-for="item in jobStatus"
                  v-if="scope.row.status === item.value">{{ item.label }}
            </span>
            <el-tooltip class="item"
                        v-if="scope.row.error_message"
                        effect="dark"
                        :content="'错误信息:' + scope.row.error_message"
                        placement="top-start">
            <span class="multi-line">
              {{ scope.row.error_message }}
            </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间 更新时间"
                         width="160">
          <template slot-scope="scope">
            {{ scope.row.created_at }}<br>
            {{ scope.row.updated_at }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <el-button size="mini"
                       v-if="scope.row.upload_path_url && allowDownload(scope.row)"
                       type="primary"
                       @click="onDownloadFile(scope.row, 'upload_path')">
              下载源文件
            </el-button>
            <el-button size="mini"
                       v-if="scope.row.error_path_url && allowDownload(scope.row)"
                       type="danger"
                       @click="onDownloadFile(scope.row, 'error_path')">
              下载错误文件
            </el-button>
            <el-button size="mini"
                       v-if="scope.row.export_path_url && allowDownload(scope.row)"
                       type="success"
                       @click="onDownloadFile(scope.row, 'export_path')">
              下载导出文件
            </el-button>
          </template>
        </el-table-column>


      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import taskMixins from '@/views/task/task.mixins'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'
import { sjDownload } from '@/vendor/sj-download'
import { getToken } from '@utils/auth'

export default {
  mixins: [table, taskMixins, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      all_tasks: [
        {'task_id': 1, 'task_name': '财务导出回款列表'},
        {'task_id': 2, 'task_name': '财务导出回款核销详情'},
        {'task_id': 3, 'task_name': '财务导出开票列表'},
        {'task_id': 4, 'task_name': '财务导出开票回款明细'},
        {'task_id': 5, 'task_name': '财务导出开票未回款明细'},
        {'task_id': 6, 'task_name': '财务导出财务格式的付款数据'},
        {'task_id': 7, 'task_name': '财务导出付款明细'},
        {'task_id': 8, 'task_name': '财务导出预付款冲销明细'},
        {'task_id': 9, 'task_name': '财务导出预付款冲销状态明细'},
        {'task_id': 10, 'task_name': '财务按条件导出预付款数据'},
      ],
      jobStatus: [
        {value: 1, label: '待执行'},
        {value: 2, label: '运行中'},
        {value: 3, label: '失败'},
        {value: 4, label: '成功'},
        {value: 5, label: '取消中'},
        {value: 6, label: '已取消'},
      ],
      search: {
        task_type: null,
      },
      searchFieldType: {
        task_type: Number,
      }
    }
  },
  created () {},
  watch: {},
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
    }),
  },
  methods: {
    ...Vuex.mapActions([]),
    getTableData (params) {
      if (!params.hasOwnProperty('task_type')) {
        params.task_type = this.all_tasks.map(task => task.task_id)
      }
      return request.common('queryFinanceExportJobsApi', params)
    },
    allowDownload (row) {
      if (this.loginUser.usertype + '' === '1') {
        return true // 超管支持下载所有任务的相关文件
      }
      return (this.loginUser.id + '') === (row.admin_id + '')
    },
    onDownloadFile (row, type) {
      sjDownload(
        _.get(row, type + '_url', ''),
        {'SJ-Auth-Token': getToken()},
        _.get(row, type + '_filename')
      )
    },
  },
}
</script>

<style lang="scss"
       scoped>
.multi-line {
  color: #f35050;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 显示的行数 */
  overflow: hidden; /* 隐藏溢出的内容 */
  width: 130px; /* 设置元素宽度 */
}
</style>



// WEBPACK FOOTER //
// src/views/batch-jobs/pages/FinanceBatchJobTable.vue